export default "__VITE_ASSET__0esY_MX6__"